export default function () {
  if (document.querySelector('#contact-us')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "contact" */ '../_03_organisms/contact-us'
    ).then(({ default: contactForm }) => {
      contactForm();
    });
  }
}
